import { Card, CardContent, CardFooter } from "./ui/card"
import { Button } from "./ui/button"
import { Calendar } from "lucide-react"
import { Link } from "react-router-dom"
 
export function DoctorCard({ 
  name, 
  specialty, 
  experience, 
  image, 
  href, 
  hospitalDoctorId
}) {
  return (
    <Card className="overflow-hidden transition-all hover:shadow-md hover:translate-y-[-5px] duration-300">
      <Link to={href} className="block group">
        <div className="relative w-full aspect-square bg-gray-50 flex items-center justify-center overflow-hidden">
          <img
            src={image || "/placeholder.svg"}
            alt={name}
            className="object-contain max-w-full max-h-full p-2 transition-transform duration-300 group-hover:scale-105"
          />
        </div>
      </Link>
      <CardContent className="p-4">
        <Link to={href} className="hover:text-primary transition-colors">
          <h3 className="text-lg font-bold">{name}</h3>
        </Link>
        <p className="text-primary">{specialty}</p>
        <p className="text-sm text-muted-foreground">{experience}</p>
      </CardContent>
      <CardFooter className="p-4 pt-0">
        {hospitalDoctorId ? (
          <Link 
            to={`/hospital-visit?doctorid=${hospitalDoctorId}`} 
            className="w-full"
          >
            <Button
              className="w-full gap-2 bg-primary text-white border border-primary hover:bg-white hover:text-primary transition-colors"
            >
              <Calendar className="mr-2 h-5 w-5" />
              Book an Appointment
            </Button>
          </Link>
        ) : (
          <Button
            className="w-full gap-2 bg-gray-200 text-gray-500 border border-gray-200"
            disabled
          >
            <Calendar className="mr-2 h-5 w-5" />
            Book an Appointment
          </Button>
        )}
      </CardFooter>
    </Card>
  )
}